module.exports = __webpack_public_path__ + "static/media/ClearHalfWall.87a6264c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Showers/ClearHalfWall.jpg
// module id = 135
// module chunks = 0